var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"29.5","cy":"29.5","r":"27.5","stroke":"white","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M18.2021 40.7979L40.7979 18.2021M18.2021 18.2021L40.7979 40.7979","stroke":"white","strokeWidth":"4","key":1})]);
}

Close.defaultProps = {"width":"59","height":"59","viewBox":"0 0 59 59","fill":"none"};

module.exports = Close;

Close.default = Close;
